<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
    <div class="main-content side-content pt-0 ml-0">
        <div class="main-container container-fluid scrol">
            <div class="inner-body">
                <div class="row row-sm">
                    <div class="col-lg-12">
                        <div class="card custom-card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-5">
                                    <div class=" d-flex align-items-center pl-3">
                                        <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                                        <div class="ml-2">
                                            <h3 class="main-content-label mb-1"><b>
                                                    HOLIDAY DATES
                                                </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                List Of Holiday Dates
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2" [formGroup]="HolidaySearchForm">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>Choose From Date</mat-label>
                                    <input class="color" matInput [matDatepicker]="picker3"
                                        placeholder=" Date" formControlName="FromDate" (dateChange)="ToDateSearch()">
                                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                    <mat-datepicker #picker3></mat-datepicker>
                                </mat-form-field>
                            </div>
                                <div class="col-md-2" [formGroup]="HolidaySearchForm">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Choose To Date</mat-label>
                                        <input class="color" matInput [matDatepicker]="picker4"
                                            placeholder=" Date" formControlName="ToDate" (dateChange)="ToDateSearch()" [disabled]="!isToDateEnabled">
                                        <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                        <mat-datepicker #picker4></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2" [formGroup]="HolidaySearchForm">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>{{'header.faculty-data.titleList.Search' | translate}}
                                        </mat-label> <input class="color" matInput placeholder="Search"
                                        (keyup)="keypress()" formControlName="SearchString">
                                        <mat-icon matSuffix>search</mat-icon>
                                    </mat-form-field>
                                </div>
                                    <div class="col-md-1 prpl">
                                        <button id="addBtn" type="button"
                                            class="btn btn-primary btn-icon-text  mt-1"
                                            (click)="addnewrecord()">
                                            <span style="display: flex; align-items: center;">
                                                <img width="20vh" src="../../assets/img/plus.gif"
                                                    style="margin-right: 5px;">
                                                    New
                                            </span>
                                        </button>
                                    </div>

                                </div>
                                <hr class="mt-2">
                                <div class="table-responsive table-container">
                                    <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                                        <thead>
                                            <tr>
                                                <th class="f600" text-center>
                                                    From Date
                                                </th>
                                                <th class="f600" text-center>
                                                    To Date
                                                </th>
                                                <th class="f600">
                                                    Holiday Name
                                                </th>
                                                <th width="10%" class="f600 text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody id="table_data">
                                            <tr *ngFor="let holiday of holidayList;">
                                                 <td>
                                                     {{holiday.FromDate | date:'dd/MM/yyyy'}} 
                                                    </td>
                                                    <td>
                                                        {{holiday.ToDate | date:'dd/MM/yyyy'}} 
                                                       </td>
                                                <td>
                                                    {{holiday.HolidayName}} 
                                                </td>
                                                <td class="text-center"> <a class="floating mr-2 pr-3" title="Edit"
                                                        (click)="prepopulateRecord(holiday)"> <i class="fa fa-edit "></i>
                                                    </a> 
                                                    <!-- <a class=" ml-2 floating" title="Delete"
                                                        (click)="deleteData(holiday)"> <i class="fas fa-trash"></i>
                                                    </a> -->
                                                 </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                [pageSizeOptions]="pageSizeOptions"
                                (page)="onPageChange($event)"></mat-paginator>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </form>
</body>